"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var utils_1 = require("@doshexchnage/utils");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var constants_1 = require("../constants");
function useRenderCellViews(rowActions) {
    var renderCellViews = (0, react_3.useCallback)(function (segment) {
        var _a, _b, _c, _d, _e;
        var enteredCount = (_b = (_a = segment.actions) === null || _a === void 0 ? void 0 : _a.filter(function (action) { return action.trigger === "entered"; }).length) !== null && _b !== void 0 ? _b : 0;
        var leftCount = (_d = (_c = segment.actions) === null || _c === void 0 ? void 0 : _c.filter(function (action) { return action.trigger === "left"; }).length) !== null && _d !== void 0 ? _d : 0;
        var buildStatus = (0, constants_1.buildStatusChip)(segment.build_status);
        return [
            {
                key: "name",
                content: ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-nowrap text-sm font-medium text-default-foreground", children: segment.name }), segment.description ? (0, jsx_runtime_1.jsx)("span", { className: "max-w-[260px] truncate text-xs text-muted", children: segment.description }) : null] })),
            },
            {
                key: "member_count",
                content: ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1 text-sm text-default-foreground", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:users-group-rounded-linear", width: 16, className: "text-muted" }), ((_e = segment.member_count) !== null && _e !== void 0 ? _e : 0).toLocaleString()] })),
            },
            {
                key: "action_count",
                content: ((0, jsx_runtime_1.jsxs)("div", { className: "text-nowrap text-sm text-muted", children: [enteredCount, " ", constants_1.triggerLabels.entered.toLowerCase(), ", ", leftCount, " ", constants_1.triggerLabels.left.toLowerCase()] })),
            },
            {
                key: "publish",
                content: segment.publish ? ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap", size: "sm", variant: "soft", color: "accent", children: "Synced" })) : ((0, jsx_runtime_1.jsx)("span", { className: "text-sm text-muted", children: "Off" })),
            },
            {
                key: "build_status",
                content: ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap", size: "sm", variant: "soft", color: buildStatus.color, children: buildStatus.label })),
            },
            {
                key: "updated_at",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: segment.updated_at ? (0, utils_1.formatDateTime)(new Date(segment.updated_at)) : "N/A" }),
            },
            {
                key: "row_actions",
                content: (0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-end gap-2", children: rowActions(segment).map(function (_a) {
                        var element = _a.element;
                        return element;
                    }) }),
            },
        ];
    }, [rowActions]);
    return (0, react_3.useMemo)(function () { return ({ renderCellViews: renderCellViews }); }, [renderCellViews]);
}
